import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { refreshStoredUserSession } from "../../../services/users/user-services";

/**
 * On app load / after login, refresh user from API so subscription_id
 * and active_subscription match the server.
 */
export function SubscriptionSessionSync({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const ran = useRef(false);

  useEffect(() => {
    if (!isAuthenticated) {
      ran.current = false;
      return;
    }
    if (ran.current) return;
    ran.current = true;
    refreshStoredUserSession();
  }, [isAuthenticated]);

  return children;
}
